<div class="value-card-container" (click)="onSelectTime(idx, hourAndUnit, date)"
  [ngClass]="{'is-selected': idx === (this.qrCodesService.currentSelectedCard | async).idx}">

  <div class="value-card" *ngIf="hourAndUnit && hourAndUnit.length >= 2">
    <div class="health-idx-rectangle" [class]="dashboardService.getQuality(healthIdx)"></div>
    <app-text class="measure-time-hour">{{hourAndUnit[0]}}</app-text>
    <app-text class="measure-time-unit">{{hourAndUnit[1]}}</app-text>
  </div>

</div>